/**
 * packet.ts
 * ESP8266のパケットフォーマット構築。
 * writetoGB()のパケットフォーマット:  P{seqNo}{checksum:2hexUPPER}{data}\0
 */

const HEX_DIGITS = "0123456789ABCDEF";

function toHex2(val: number): string {
    return HEX_DIGITS[(val >> 4) & 0x0f] + HEX_DIGITS[val & 0x0f];
}

/**
 * データ配列（\0を含まない生バイト）からパケットを生成する。
 * 返り値はnull終端を含むUint8Array。
 */
export function buildPacket(seqNo: 0 | 1, data: Uint8Array): Uint8Array {
    // チェックサム計算 (Sum modulo 256)
    let checksum = 0;
    for (let i = 0; i < data.length; i++)
        checksum = (checksum + data[i]) & 0xff;

    // 'P' + seqNo + checksum2hex + data + '\0'
    const packetLen = 1 + 1 + 2 + data.length + 1;
    const packet = new Uint8Array(packetLen);
    packet[0] = 0x50; // 'P'
    packet[1] = 0x30 + seqNo; // '0' or '1'
    packet[2] = toHex2(checksum).charCodeAt(0);
    packet[3] = toHex2(checksum).charCodeAt(1);
    packet.set(data, 4);
    packet[packetLen - 1] = 0x00;
    return packet;
}

/**
 * 文字列をUint8Arrayに変換してパケット化する便利関数。
 * ASCII文字列データ（WAIT, TEND等）向け。
 */
export function buildStringPacket(seqNo: 0 | 1, str: string): Uint8Array {
    const data = new TextEncoder().encode(str);
    return buildPacket(seqNo, data);
}
